<template>
    <div class="form-group">
        <validation-item :label="label" :name="validationFieldName" :rules="rules" :vid="vid">
            <template>
                <textarea
                    v-if="maxLength!==null"
                    :value="value"
                    @input="handleInputChange"
                    :type="type"
                    :maxlength="maxLength"
                    class="form-control"
                    :placeholder="placeholder"
                />
                <textarea
                    v-else
                    :value="value"
                    @input="handleInputChange"
                    :type="type"
                    class="form-control"
                    :placeholder="placeholder"
                />
                <div class="text-left">
                    <p
                        v-if="value && maxLength!==null"
                        class="badge position-absolute"
                        :class="{ 'badge-success': value.length !== maxLength,
                            'badge-danger': value.length === maxLength }"
                    >
                        {{ value.length }} /
                        {{ maxLength }}
                    </p>
                </div>
            </template>
        </validation-item>
    </div>
</template>

<script>
import ValidationItem from "./ValidationItem";

export default {
    name: "ValidationTextArea",
    components: {ValidationItem},
    props: {
        label: {
            type: String,
            default: ''
        },
        validationFieldName: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Object, Array],
            default: ''
        },
        vid: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        maxLength: {
            type: [Number, null],
            default: null
        }
    },
    methods: {
        handleInputChange(e) {
            this.$emit('input', e.target.value)
        }
    }
}
</script>

<style scoped>

</style>
